module.exports = __webpack_public_path__ + "static/media/clinally_logo.52616e5d.png";